import { render } from "./OwnerDashboard.vue?vue&type=template&id=36c522f4"
import script from "./OwnerDashboard.vue?vue&type=script&lang=js"
export * from "./OwnerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__